import React, { useState, useContext, useEffect } from 'react';
import styles from '../css/Login.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import axiosInstance from '../config/axiosConfig';

export default function Login() {
  const [fuser, setFuser] = useState('');
  const [fpassword, setFpassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  // 1. Si ya existe un usuario en el contexto, no mostrar el login y enviarlo a /home
  useEffect(() => {
    if (user) {
      navigate('/home', { replace: true });
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();

    setError('');
    setSuccess('');

    if (!fuser.trim() || !fpassword.trim()) {
      setError('Por favor complete todos los campos');
      return;
    }

    setLoading(true);

    try {
      const response = await axiosInstance.post('/login', {
        username: fuser.trim(),
        password: fpassword.trim()
      });

      const userData = response.data.user || response.data.User;

      const sessionData = {
        id: userData.id || userData.Id,
        username: userData.username || userData.Username,
        email: userData.email || userData.Email,
        firstName: userData.firstName || userData.FirstName || '',
        firstSurname: userData.firstSurname || userData.FirstSurname || '',
        idRol: userData.idRol || userData.IdRol || 0
      };

      // 2. Persistir en localStorage inmediatamente
      localStorage.setItem('user', JSON.stringify(sessionData));

      // 3. Actualizar el estado global
      setUser(sessionData);

      setSuccess(response.data.message || response.data.Message || 'Login exitoso');
      setTimeout(() => navigate('/home'), 500);

    } catch (err) {
      const serverMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.response?.data?.Error;

      if (serverMessage) {
        setError(serverMessage);
      } else if (err.request) {
        setError('No se pudo conectar con el servidor (verifique la red)');
      } else {
        setError('Error al procesar la solicitud');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.tablesContainer}>
        <form onSubmit={handleLogin}>
          <table className={styles.infoTable}>
            <tbody>
              <tr>
                <td className={styles.tableHeader}>
                  <div className={styles.headerContent}>
                    <span>Conectar</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td className={styles.tableBody}>
                  <div className={styles.inputGroup}>
                    <label htmlFor="fuser">Nombre de usuario:</label>
                    <input
                      type="text"
                      id="fuser"
                      name="fuser"
                      value={fuser}
                      onChange={(e) => setFuser(e.target.value)}
                      disabled={loading}
                      autoFocus
                    />
                  </div>

                  <div className={styles.inputGroup}>
                    <label htmlFor="fpassword">Contraseña:</label>
                    <input
                      type="password"
                      id="fpassword"
                      name="fpassword"
                      value={fpassword}
                      onChange={(e) => setFpassword(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <button
                    type="submit"
                    className={styles.btnSubmit}
                    disabled={loading}
                  >
                    {loading ? 'Conectando...' : 'Aceptar'}
                  </button>

                  {error && (
                    <p style={{ 
                      color: '#d32f2f', 
                      marginTop: '12px', 
                      fontSize: '13.5px',
                      fontWeight: 500,
                      textAlign: 'center'
                    }}>
                      {error}
                    </p>
                  )}

                  {success && (
                    <p style={{ 
                      color: '#2e7d32', 
                      marginTop: '12px', 
                      fontSize: '13.5px',
                      fontWeight: 500,
                      textAlign: 'center'
                    }}>
                      {success}
                    </p>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>

      <div className={styles.forgotLink}>
        <Link to="/">Olvidó su Contraseña</Link>
      </div>
    </div>
  );
}